<header class="portal-header">
  <div class="portal-header-inner">
    <!-- Brand Logo & Portal Badge -->
    <a class="brand-link" [routerLink]="authService.isAuthenticated() ? ['/dashboard'] : ['/login']">
      <img src="assets/images/beefund.png" alt="BeeFund" class="brand-logo" />
      <span class="portal-badge">Portal</span>
    </a>

    <!-- Right Actions: Navigation, Language Switcher & Logout -->
    <div class="header-actions">
      @if (authService.isAuthenticated() && !router.url.includes('/login')) {
        <a
          [routerLink]="['/dashboard']"
          class="nav-link"
          [class.active]="router.url === '/dashboard'"
        >
          <mat-icon class="nav-icon">space_dashboard</mat-icon>
          <span class="hidden sm:inline" translate>Campaigns</span>
        </a>
      }

      <!-- Language Selector (matching beefund.app header) -->
      <div class="lang-switcher" role="group" aria-label="Language selection">
        <button
          type="button"
          class="lang-btn"
          [class.active]="(translateService.currentLang || currentLang) === 'nl'"
          (click)="switchLanguage('nl')"
        >
          NL
        </button>
        <span class="lang-divider">|</span>
        <button
          type="button"
          class="lang-btn"
          [class.active]="(translateService.currentLang || currentLang) === 'en'"
          (click)="switchLanguage('en')"
        >
          EN
        </button>
      </div>

      @if (authService.isAuthenticated() && !router.url.includes('/login')) {
        <button type="button" class="logout-btn" (click)="logout()" [title]="'logout' | translate">
          <mat-icon class="logout-icon">logout</mat-icon>
          <span class="hidden sm:inline" translate>logout</span>
        </button>
      }
    </div>
  </div>
</header>
